import React from 'react';
import {Container, Paper, Typography} from "@mui/material";
import {styled} from '@mui/material/styles';
import OutlineButton from "../../Common/OutlineButton";

const PREFIX = 'Accommodation';
const classes = {
    root: `${PREFIX}-root`,
    titleContainer: `${PREFIX}-titleContainer`,
    accommodationTitle: `${PREFIX}-accommodationTitle`,
    dealsTitle: `${PREFIX}-dealsTitle`,
    dealsButton: `${PREFIX}-dealsButton`,
}
const PaperAccommodation = styled(Paper)(({theme}) => ({
    [`&.${classes.root}`]: {
        marginTop: '50px'
    },
    [`& .${classes.titleContainer}`]: {
        marginLeft: '10px',
        marginRight: '10px',
        paddingTop: '20px',
        marginBottom: '20px',
    },
    [`& .${classes.accommodationTitle}`]: {
        fontSize: '2.4rem',
        fontWeight: '500',
        textAlign: 'left',
    },
    [`& .${classes.dealsTitle}`]: {
        color: theme.palette.common.white,
        fontWeight: '700',
    },
    [`& .${classes.dealsButton}`]: {
        letterSpacing: '2.5px',
        marginTop: '20px',
        display: 'inline-block',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(30px)',
    }
}));

const Accommodation = () => {
    const goToHotelDeals = () => {
        const url = `https://nautilusliveaboards.com/contact-us/`;
        window.open(url, '_blank');
    };

    return (
        <PaperAccommodation className={classes.root} elevation={3}>
            <Container className={classes.titleContainer}>
                <Typography variant={"h4"} className={classes.accommodationTitle}>
                    Looking for an accommodation?
                </Typography>
            </Container>
            <div style={{backgroundImage: 'url(https://s3.ca-central-1.amazonaws.com/nautilusliveaboards.com/images/addons/special-hotel-deals.jpg)', height: '270px', width: '100%', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', objectPosition: 'center center'}}>
                <div style={{marginLeft: '20px', marginRight: '20px', paddingTop: '30px'}}>
                    <Typography variant="h3" className={classes.dealsTitle}>Special Hotel Deals</Typography>
                    <OutlineButton className={classes.dealsButton} onClick={goToHotelDeals}>View Deals</OutlineButton>
                </div>
            </div>
            {/*<div style={{backgroundImage: 'url(https://place-hold.it/270x270/558fbc?text=%20)', height: '270px'}}>
                <div style={{marginLeft: '20px', marginRight: '20px', paddingTop: '20px'}}>
                    <Typography variant="h3" className={classes.dealsTitle}>Villas in Cabo San Lucas</Typography>
                    <OutlineButton className={classes.dealsButton}>View Deals</OutlineButton>
                </div>
            </div>*/}
        </PaperAccommodation>
    );
};

export default Accommodation;